module.exports = __webpack_public_path__ + "assets/4f7ca0485c3be85b3d96a065509bbb06.mp3";